import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import HeaderTransprent from "../Home/Component/HeaderTransprent";
import Footer from "../Home/Component/Footer";
import AOS from "aos";
import Ready from "../../../components/Ready";
import { Helmet } from "react-helmet";

const list = require('./content.json')

let sectorList = [...new Set(list.map((ele) => (ele.Sector)))]


class TeenCareerLibrariesDetails extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      activeTab: 1,
      currentImage: null,
      saveSuccess: false,

      isScrolled: false,
      showButton1: false,
      showButton2: false,
      showButton3: false,
      showButton4: false,

      openAccordion: 1,

      fieldslogin: {},
      errorslogin: {},

      formData: {
        quantity: 1,
        productId: this.props.match.params.id2,
        licensee: this.props.match.params.id1,
      },
      crrSector: "",
      crrJob: ""
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.dispatch(assessmentActions.userAssessmentUserProfile('getAssessmentCartCount'));
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
      delay: 100,
    });
  }

  handleTabClick = (tab) => {
    this.setState({
      activeTab: tab,
    });
  };


  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    if (field === "my-cart") {
      if (
        !(userAssessmentUserProfileData && userAssessmentUserProfileData.email)
      ) {
        this.props.history.push(`/assessment/` + "sign-in");
      } else {
        this.props.history.push(`/assessment/` + field);
      }
    } else {
      this.props.history.push(`/assessment/` + field);
    }
  };

  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  handleDownload = () => {
    let code = "TalentPlusStrengths21";
    const link = document.createElement("a");
    link.href = "/" + code.toString() + ".pdf";
    link.download = code.toString() + ".pdf";
    link.click();
  };

  handleRedirect = () => {
    this.props.history.push("/assessment/how-talentplus-strength-works");
    window.scrollTo(0, 0);
  };

  closeOrgTypeModal = () => {
    this.setState({ showOrgTypeModal: false })
  }

  handleOptionInput = (value) => {
    let { formData } = this.state;
    formData["type"] = value;
    this.setState({ formData });
  };

  handleToggle(index) {
    this.setState({
      openAccordion: this.state.openAccordion === index ? null : index,
    });
  }

  handelSelector = (type, ele) => {
    if (type === "sector") {
      this.setState({ crrSector: ele });
    } else if (type === "job") {
      this.setState({ crrJob: ele });
    }
  }

  render() {

    let { assessment } = this.props;
    let { userAssessmentUserProfileData, getAssessmentCartCountData, getAssessmentPackagesShortListData, } = assessment;

    const { crrSector, crrJob } = this.state;

    let initSector = "";
    if (crrSector) {
      initSector = crrSector;
    } else {
      if (sectorList && sectorList.length > 0) {
        initSector = sectorList[0];
      }
    }

    let jobList = [];
    if (list && list.length > 0) {
      jobList = list.filter(prev => prev.Sector === initSector)
    }

    console.log('jobListjobListjobListjobListjobListjobListjobListjobListjobListjobList', jobList);

    let initJob = "";
    if (crrJob) {
      initJob = crrJob;
    } else {
      if (jobList && jobList.length > 0) {
        initJob = jobList[0]["JobTitle"];
      }
    }

    console.log('initJobinitJobinitJobinitJobinitJobinitJobinitJob', initJob);



    return (
      <div className="overflow-hidden ">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Empowering Teen Talent Potential for Meaningful Growth</title>
          <meta name="description" content="Elevate teen potential with Teenager Talent assessment, fostering confidence, purposeful living, and transformative growth." />
          <link rel="canonical" href="https://www.talentplusstrengths.com/#/assessment/home" />
        </Helmet>

        <section
          className="bg-[#F9FAFB] w-full h-auto bg-center  bg-cover bg-no-repeat  "
        >
          <HeaderTransprent
            handleSignInPage={this.handleSignInPage}
            userDetails={userAssessmentUserProfileData}
            logout={this.logout}
            gotoPage={this.gotoPage}
            cartCount={getAssessmentCartCountData ? getAssessmentCartCountData : 0}
            props2={this.props}
            prodList={getAssessmentPackagesShortListData}
            gotoMyAccount={this.gotoMyAccount}
          />

          {/* Hero Section */}
          <div className="w-full h-full border-t border-black/10">
            <div data-aos="fade-right" className="text-base text-[#212121] font-normal  pt-4 
                left-0 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto space-x-1">
              <span className="cursor-pointer" onClick={() => this.gotoPage("home")}>Home</span>  {'>'}
              <span className="cursor-pointer" onClick={() => this.gotoPage("teen-career-guidance")}>Career Guidance Program</span>
              <span>   {'>'}</span>
              <span className="cursor-pointer" onClick={() => this.gotoPage("teen-career-guidance")}>Career Libraries</span>
              <span className="text-[#2196F3]">   {'>'}</span>
              <span className="text-[#2196F3]">Details</span>
            </div>
            <div className="flex flex-col w-full h-full gap-10 md:pt-10 pt-6 pb-20  md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto  ">
              {/* Sector section Code */}
              <div className="border bg-white rounded-xl w-[28rem] flex-shrink-0 h-fit lg:block hidden">
                <div className="px-6 py-4 flex justify-between items-center border-b">
                  <h1 className="xl:text-xl text-xl   font-semibold text-[#212121] uppercase">Sectors</h1>
                  {sectorList && sectorList.length > 0 && (
                    <p className="text-xl text-[#212121]/70 font-medium">{sectorList.length}</p>
                  )}
                </div>

                <div className="text-base md:text-base p-6 font-medium text-[#212121]/80 space-y-2 overflow-y-auto min-h-auto max-h-[36rem]">
                  {sectorList && sectorList.length > 0 && sectorList.map((ele) =>
                    <p onClick={(() => this.handelSelector("sector", ele))} className={initSector === ele ? "cursor-pointer truncate capitalize px-6 py-3 rounded-lg bg-[#212121] text-[#fff]" : "cursor-pointer truncate capitalize px-6 py-3 rounded-lg bg-[#fff] text-[#212121]"}>
                      {ele}
                    </p>
                  )}
                </div>
              </div>


              <div className="w-full space-y-4">

                <div className="flex flex-col gap-2 border-b border-[#212121]/20 pb-4">
                  <h1 className="capitalize xl:text-2xl text-lg font-semibold text-[#212121]">{initSector}</h1>
                  <button className="lg:hidden block px-3 py-1 rounded-lg bg-[#fff] border border-[#2196F3] text-[#2196F3] font-medium text-sm w-fit uppercase flex items-center space-x-2">
                    <span> Change Sectors </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 6l6 6l-6 6" /></svg>
                  </button>
                </div>

                {/* tabs */}
                <div className="capitalize 2xl:text-base text-sm w-full flex flex-wrap gap-2 py-2">
                  {jobList && jobList.length > 0 && jobList.map((ele) =>
                    <button onClick={(() => this.handelSelector("job", ele.JobTitle))} className={initJob === ele.JobTitle ? "px-3 py-2 rounded-lg bg-[#2196F3] border border-[#2196F3] text-[#fff] font-medium" : "px-3 py-2 rounded-lg bg-white border border-[#212121]/20  text-[#212121]/70 font-medium"}>{ele.JobTitle}</button>
                  )}
                </div>

                {/* acordian 1 */}
                <div className="bg-white border border-[#212121]/20 rounded-xl overflow-hidden">
                  <div onClick={() => this.handleToggle(1)} className={`px-6 py-4 flex justify-between items-center border-b cursor-pointer ${this.state.openAccordion === 1 ? "bg-[#2196F3]/10" : "bg-white"}`}>
                    <h1 className="xl:text-xl text-lg font-semibold text-[#212121] capitalize ">Key role & responsibility</h1>
                    {this.state.openAccordion === 1 ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-plus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                    )}
                  </div>
                  {this.state.openAccordion === 1 && (
                    <>
                      {jobList && jobList.length > 0 && jobList.map((ele) => (
                        ele.JobTitle === initJob && (
                          <div className="md:p-6 p-4 grid md:grid-cols-2 grid-cols-1 gap-4">
                            {Object.keys(ele.KeyRolesAndResponsibilities).map((section, sectionIndex) => (
                              <div className="border rounded-xl overflow-hidden" key={ele.JobTitle}>
                                <div key={sectionIndex}>
                                  <h2 className="capitalize p-4 py-2 bg-[#212112]/5 xl:text-base text-[#212121] font-semibold">
                                    {section.replace(/([A-Z])/g, ' $1').trim()}
                                  </h2>
                                  <div className="p-4">
                                    <ul className="list-disc pl-6 space-y-2 text-sm">
                                      {ele.KeyRolesAndResponsibilities[section].map((item, itemIndex) => (
                                        <li key={itemIndex}>{item}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            ))}

                          </div>
                        )
                      ))}
                    </>
                  )}
                </div>

                {/* acordian 2 */}
                <div className="bg-white border border-[#212121]/20 rounded-xl overflow-hidden">
                  <div onClick={() => this.handleToggle(2)} className={`px-6 py-4 flex justify-between items-center border-b cursor-pointer ${this.state.openAccordion === 2 ? "bg-[#2196F3]/10" : "bg-white"}`}>
                    <h1 className="xl:text-xl text-lg font-semibold text-[#212121] capitalize">Work Activities</h1>
                    {this.state.openAccordion === 2 ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-plus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                    )}
                  </div>
                  {this.state.openAccordion === 2 && (
                    <>{jobList && jobList.length > 0 && jobList.map((ele) => (
                      ele.JobTitle === initJob && (
                        <div className="md:p-6 p-4 grid md:grid-cols-2 grid-cols-1 gap-4" key={ele.JobTitle}>
                          {ele.WorkActivities.map((activity, index) => (
                            <div className="border rounded-xl overflow-hidden flex" key={index}>
                              <div className="p-4 py-2 bg-[#212112]/5 text-[#2196F3] flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                  <path d="M0.819336 11.7609C4.16387 15.3797 7.40668 18.6375 10.5239 22.7578C13.9129 16.0172 17.3817 9.25312 23.1051 1.92796L21.5629 1.22156C16.7301 6.34687 12.9754 11.1984 9.71293 16.9641C7.44418 14.9203 3.77762 12.0281 1.53887 10.5422L0.819336 11.7609Z" fill="currentColor"></path>
                                </svg>
                              </div>
                              <div className="p-4 py-2 flex items-center">
                                <p className="text-sm">
                                  {activity}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )
                    ))}

                    </>
                  )}
                </div>

                {/* acordian 3 */}
                <div className="bg-white border border-[#212121]/20 rounded-xl overflow-hidden">
                  <div onClick={() => this.handleToggle(3)} className={`px-6 py-4 flex justify-between items-center border-b cursor-pointer ${this.state.openAccordion === 3 ? "bg-[#2196F3]/10" : "bg-white"}`}>
                    <h1 className="xl:text-xl text-lg font-semibold text-[#212121] capitalize">Minimum Education Qualification</h1>
                    {this.state.openAccordion === 2 ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-plus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                    )}
                  </div>
                  {this.state.openAccordion === 3 && (
                    <>
                      {jobList && jobList.length > 0 && jobList.map((ele) => (
                        ele.JobTitle === initJob && (
                          <div key={ele.JobTitle} className="md:p-6 p-4 grid md:grid-cols-3  grid-cols-1 gap-4">
                            {Object.keys(ele.MinimumEducationQualification).map((degree, index) => (
                              <div className="border rounded-xl overflow-hidden" key={index}>
                                <h2 className="capitalize p-4 py-2 bg-[#212112]/5 xl:text-base text-[#212121] font-semibold">
                                  {degree.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                                </h2>
                                <div className="p-4">
                                  <p className="text-sm">
                                    {ele.MinimumEducationQualification[degree]}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>
                        )
                      ))}
                    </>
                  )}
                </div>

                {/* acordian 4 */}
                <div className="bg-white border border-[#212121]/20 rounded-xl overflow-hidden">
                  <div onClick={() => this.handleToggle(4)} className={`px-6 py-4 flex justify-between items-center border-b cursor-pointer ${this.state.openAccordion === 4 ? "bg-[#2196F3]/10" : "bg-white"}`}>
                    <h1 className="xl:text-xl text-lg font-semibold text-[#212121] capitalize">JobOpportunities</h1>
                    {this.state.openAccordion === 2 ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-plus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                    )}
                  </div>
                  {this.state.openAccordion === 4 && (
                    <>

                      {jobList && jobList.length > 0 && jobList.map((ele) => (
                        ele.JobTitle === initJob && (
                          <div className="md:p-6 p-4 grid md:grid-cols-2 grid-cols-1 gap-4" key={ele.JobTitle}>
                            {ele.JobOpportunities.map((opportunity, index) => {
                              const [heading, ...description] = opportunity.split(": ");
                              return (
                                <div key={index} className="border rounded-xl overflow-hidden">
                                  <h2 className="capitalize p-4 py-2 bg-[#212112]/5 xl:text-base text-[#212121] font-semibold">
                                    {heading}
                                  </h2>
                                  <div className="p-4">
                                    <p className="text-sm">
                                      {description.join(": ")}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )
                      ))}


                      {/* {jobList && jobList.length > 0 && jobList.map((ele) => (
                        ele.JobTitle === initJob && (
                          <div className="md:p-6 p-4 grid md:grid-cols-3 grid-cols-1 gap-4">
                            {Object.keys(ele.JobOpportunities).map((degree, index) => (
                              <div key={index} className="border rounded-xl overflow-hidden">
                                <h2 className="capitalize p-4 py-2 bg-[#212112]/5 xl:text-base text-[#212121] font-semibold">{degree.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:</h2>
                                <div className="p-4">
                                  <p className="text-sm">{ele.JobOpportunities[degree]}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        )
                      ))} */}
                    </>
                  )}
                </div>

              </div>
            </div>
          </div>
        </section>

        <Ready />

        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />
      </div>
    );
  }
}
TeenCareerLibrariesDetails.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(TeenCareerLibrariesDetails);
